export default __webpack_public_path__ + "static/media/blueCubeSide.2c3d7dc9.svg";